import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware((to) => {
  if (to.name === 'auth-callback') return

  if (to.name === 'demo-call-callSlug') return

  if (to.name === '404') return

  if (to.name === '403') return

  if (to.name === 'invite') return

  const authStore = useAuthStore()

  if (['signin'].includes(to.name as string) && authStore.isAuthenticated) {
    return navigateTo('/')
  }

  if (
    [
      'signin',
      'simulation-simulationId',
      'activate',
      'test-testId',
      'test-testId-feedback-testSubmissionId',
      'file-submission-testId',
      'submission-testId',
      'sequence-sequenceId',
      'sequence-sequenceId-attempt-attemptId',
      'sequence-sequenceId-attempt-attemptId-event',
      'lti-deep-link',
      'lti-launch',
    ].includes(to.name as string)
  )
    return

  const returnTo = to.fullPath

  if (!authStore.isAuthenticated && to.name !== 'signin') {
    if (returnTo !== '/') return navigateTo('/signin?returnTo=' + returnTo)

    return navigateTo('/signin')
  }
})
